import React, { useEffect, useState } from 'react'
import { Button, Table } from 'react-bootstrap';
import { mapTest } from '../../pages/products/map.test';

export default function Pagination(props) {

    const [items, setItems] = useState([])
    const [index, setIndex] = useState(0)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [maxPage, setMaxPage] = useState(1)

    function goTo(value, type = "") {
        if (type == "increment") {
            setIndex(index + value)
        } else if (type == "decrement") {
            setIndex(index - value)
        } else {
            setIndex(value)
        }
    }
    useEffect(() => {
        let itemsTemp = []
        let max = 1;
        if (props.items.length) {
            itemsTemp = props.items
            max = Math.ceil(itemsTemp.length / itemsPerPage)
        }

        setMaxPage(max)
        setIndex(0)
        setItems(itemsTemp)
    }, [props.items.length, itemsPerPage])

    return (
        <div className='py-3' >
            <Table responsive striped bordered hover size="sm">
                <thead>
                    <tr>
                        {props.labels ? props.labels.map(label => <th>{label}</th>) : <th />}
                    </tr>
                </thead>
                <tbody>
                    {items.map((item, _) => {
                        let actualIndex = _ + 1
                        if (
                            actualIndex > itemsPerPage * index &&
                            actualIndex <= (itemsPerPage * index) + itemsPerPage
                        ) {
                            return <tr>{props.dataComponent(item, _)}</tr>
                        }
                    })}
                </tbody>
            </Table>
            {!items.length ?
                props.noDataComponent || <h3 className='text-center'>Sem itens. Aperte o botão Pesquisar para atualizar a lista.</h3> 
                : 
                <div className={`row pull-right mt-2 mb-5 pb-5 ${props.onlyView || props.noFooter? "invisible":"visible"}`}>
                    <div className='mr-5'>
                        Itens por página:{"   "}
                        <select value={`${itemsPerPage}`} onChange={e => setItemsPerPage(Number(e.target.value))}>
                            <option value='5'>5</option>
                            <option value='10'>10</option>
                            <option value='15'>15</option>
                            <option value='20'>20</option>
                            <option value='25'>25</option>
                            <option value='30'>30</option>
                        </select>
                    </div>
                    {items.length <= itemsPerPage ?
                        <div className='mr-3' /> :
                        <div className='text-center h5 mr-3'>
                            {(index * itemsPerPage) + 1} - {" "}
                            {(index + 1) == maxPage ? items.length : ((index + 1) * itemsPerPage)} de {items.length}
                        </div>
                    }
                    <Button
                        size='sm'
                        id={mapTest.emitNfe.clientSelectPreviousButton}
                        disabled={!(index != 0 && !props.onlyView)}
                        variant='link'
                        className='mr-3'
                        onClick={() => goTo(1, "decrement")}
                    >
                        <span className='fas fa-angle-left h5' />
                    </Button>
                    <Button
                        variant='link'
                        id={mapTest.emitNfe.clientSelectNextButton}
                        size='sm'
                        disabled={!(items.length && index + 1 != maxPage && !props.onlyView)}
                        className='mr-3'
                        onClick={() => goTo(1, "increment")}
                    >
                        <span className='fas fa-angle-right h5' />
                    </Button>
                </div> 
            }


        </div>
    )

}


// WEBPACK FOOTER //
// ./src/components/theme/pagination/index.jsx